/* FDA 23 Sep 2026: keeps the cart attribute "Packing" (the right mailing bag for Dan) in step with the cart, so it is
   on the order however the customer checks out. The value comes from snippets/fda-packing.liquid via
   /?section_id=fda-packing-value, so the rule lives in one place.

   1. After any cart change made through fetch (add / change / update / clear) it waits 500 ms, reads the value and
      writes it with cart/update.js when it differs. This covers express buttons and the card hover Checkout link.
   2. Checkout clicks (cart page, drawer, links to /checkout): Dawn waits about 300 ms before sending a quantity change,
      so a quick click used to post the new quantities with the old note (Jed's test order #32318: 3 pouches, note said
      6). Now the click applies the form's quantities (updates[], note, other attributes) with cart/update.js, writes the
      fresh Packing value, then goes to checkout. Whatever happens it continues to checkout within 5 seconds.
   3. 25 Sep 2026 (audit): the same checkout clicks also check every Build a Box in the cart (boxIncomplete below). A box
      that is short of treats, or has lost its Build a Box line, stops checkout with a message by the button and the cart
      is left as it is. Any error or a slow answer lets checkout go ahead.
   The hidden attributes[Packing] inputs in the forms stay as the no-JavaScript fallback. */
(function () {
  if (window.__fdaPacking) return;
  window.__fdaPacking = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var busy = false;
  var again = false;

  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function setInputs(value) {
    var inputs = document.querySelectorAll('input[name="attributes[Packing]"]');
    for (var i = 0; i < inputs.length; i++) inputs[i].value = value;
  }

  function doSync() {
    return Promise.all([
      nativeFetch(root + '?section_id=fda-packing-value', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); }),
      nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var m = /data-fda-packing="([^"]*)"/.exec(res[0] || '');
      if (!m) return null;
      var want = decode(m[1]).trim();
      setInputs(want);
      var cart = res[1] || {};
      var have = (cart.attributes && cart.attributes.Packing) || '';
      if (want === have) return null;
      return nativeFetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { Packing: want } })
      });
    }).catch(function () {});
  }

  function sync() {
    timer = null;
    if (busy) { again = true; return; }
    busy = true;
    doSync().then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 500);
  }

  /* 3. Build a Box check. The box discount (Functions Creator) groups box treat lines by _fda_box_size N and needs N or
     more of them, so boxes of one size are pooled: a box that is short of treats could borrow the discount from a
     complete box. The builder can't make one (box treats are locked and a box is removed whole), but a cart API edit or
     a leftover cart can. Cart contract (assets/fda-box-builder.js): a box's treat lines share _fda_box_id and its $0
     Build a Box line carries the same id in _fda_box_parent. Every box needs that parent line and exactly N treats, with
     N the _fda_box_size on each of its lines. Resolves true when a box fails, false otherwise and on any error: a
     network problem must never block a normal order. */
  var BOX_MSG = 'One of your boxes is incomplete. Please remove it and build it again.';
  var BOX_FLAG = 'fda-box-incomplete';

  function boxIncomplete() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var boxes = {};
        ((cart && cart.items) || []).forEach(function (item) {
          var p = item.properties || {};
          var id = p._fda_box_parent || p._fda_box_id;
          if (!id) return;
          var key = 'box:' + id;
          var box = boxes[key] || (boxes[key] = { parent: false, treats: 0, sizes: [] });
          if (p._fda_box_parent) box.parent = true;
          else box.treats += item.quantity;
          box.sizes.push(parseInt(p._fda_box_size, 10));
        });
        return Object.keys(boxes).some(function (key) {
          var box = boxes[key];
          return !box.parent || box.sizes.some(function (n) { return n !== box.treats; });
        });
      })
      .catch(function () { return false; });
  }

  // The message goes just above the button's row (.cart__ctas on the cart page and in the drawer). Dawn redraws the
  // drawer on the next cart change, which clears it there; the next checkout click checks again anyway.
  function showBoxMessage(button) {
    var old = document.querySelectorAll('.fda-box-check');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    var anchor = button.closest('.cart__ctas') || button;
    if (!anchor.parentNode) return;
    var p = document.createElement('p');
    p.className = 'fda-cart-msg fda-cart-msg__error fda-box-check';
    p.setAttribute('role', 'alert');
    p.textContent = BOX_MSG;
    anchor.parentNode.insertBefore(p, anchor);
  }

  function holdCheckout(t) {
    t.removeAttribute('data-fda-going');
    t.removeAttribute('aria-busy');
    // The CHECKOUT link on a product card has no room for a message: open the cart page, which lists the boxes, and
    // show it there by Proceed to checkout (initial, below).
    if (t.tagName === 'A') {
      try { sessionStorage.setItem(BOX_FLAG, '1'); } catch (e) {}
      window.location.href = root + 'cart';
      return;
    }
    showBoxMessage(t);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(schedule, schedule);
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t || t.disabled || t.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (t.getAttribute('data-fda-going')) return;
    t.setAttribute('data-fda-going', '1');
    t.setAttribute('aria-busy', 'true');

    var target = t.tagName === 'A' ? t.href : root + 'checkout';
    var form = t.tagName === 'A' ? null : t.form;
    var step = Promise.resolve();
    if (form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        // updates are keyed by line (updates[<line key>]) since 24 Sep, so regrouped cart rows can't shift quantities.
        if (/^updates\[/.test(k) || k === 'note' || (/^attributes\[/.test(k) && k !== 'attributes[Packing]')) params.append(k, v);
      });
      if (params.toString()) {
        step = nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
          body: params.toString()
        });
      }
    }
    var go = function () { window.location.href = target; };
    var cap = new Promise(function (r) { setTimeout(r, 5000); });
    // The box check runs beside the Packing write (same /cart.js state, after the form's quantities are applied).
    Promise.race([
      step.then(function () {
        clearTimeout(timer);
        timer = null;
        return Promise.all([doSync(), boxIncomplete()]);
      }).then(function (res) { return res[1] ? 'hold' : 'go'; }),
      cap
    ]).then(function (next) {
      if (next === 'hold') holdCheckout(t);
      else go();
    }, go);
  }, true);

  // First check on page load only when the cart has items (layout/theme.liquid sets html.fda-cart-has-items), so an
  // empty-cart page view costs no extra requests. Cart changes after load are always watched.
  function initial() {
    if (document.documentElement.classList.contains('fda-cart-has-items')) setTimeout(sync, 800);
    // Sent here by a product card's CHECKOUT link because a box failed the check (holdCheckout).
    var flagged = false;
    try {
      flagged = sessionStorage.getItem(BOX_FLAG) === '1';
      if (flagged) sessionStorage.removeItem(BOX_FLAG);
    } catch (e) {}
    var button = flagged && document.querySelector('#main-cart-footer button[name="checkout"]');
    if (button) showBoxMessage(button);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initial);
  } else {
    initial();
  }
})();
